// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bVAA","type":"styles_type__10jGt","choices":"styles_choices__17o3I"};